import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StyledHtmlContent from '../common/StyledHtmlContent';

interface Feature {
  title: string;
  content: string;
}

interface OddsType {
  type: string;
  description: string;
}

const CasinoU888Section: React.FC = () => {
  const { t } = useTranslation();

  const section1Items = t('casino.section1.content', { returnObjects: true }) as OddsType[];
  const section2Items = t('casino.section2.content', { returnObjects: true }) as OddsType[];


  return (
    <>
      <Helmet>
        <title>{t('meta.casino.title')}</title>
        <meta name="description" content={t('meta.casino.description')} />
        <link rel="canonical" href="https://www.u888winbet.com/casino" />
      </Helmet>
      <section className="bg-[#1a1a1a] text-xl text-white px-4 py-8 mt-[7rem] md:mt-[11rem]">
        {/* Title */}
        <h1 className="text-center text-2xl md:text-3xl font-bold text-[#ff5c00]">
          {t('casino.title')}
        </h1>

        {/* Intro / Content */}
        <div className="mt-4 max-w-3xl mx-auto text-xl leading-relaxed text-center">
          <StyledHtmlContent html={t('casino.content')} />
        </div>

        <div className="w-full max-w-5xl mx-auto mt-10 mb-10 px-4">
          <img
            src="/u888-banner.jpg"
            alt="U888 Promotion"
            className="rounded-md w-full h-auto"
          />
          <label className="block text-center italic mt-2 text-lg">
            {t('home.image_hint')}
          </label>
        </div>

        {/* Section 1 */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mb-4">
          {t('casino.section1.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('casino.section1.content_main')} />
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {section1Items.map((cat, idx) => (
            <div key={idx}>
              <h3 className="font-semibold text-[#ffb347]">{cat.type}</h3>
              <p>{cat.description}</p>
            </div>
          ))}
        </div>

        {/* Section 2 - Features */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('casino.section2.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('casino.section2.content_main')} />
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {section2Items.map((cat, idx) => (
            <div key={idx}>
              <h3 className="font-semibold text-[#ffb347]">{cat.type}</h3>
              <p>{cat.description}</p>
            </div>
          ))}
        </div>

        {/* Section 3 - Games */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('casino.section3.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('casino.section3.content')} />
        </div>
      </section>
    </>
  );
};

export default CasinoU888Section; 